import { Component, OnInit } from '@angular/core';
import { ModalService } from '../../shared/services/modal.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import {
  trigger,
  style,
  animate,
  transition,
  state,
} from '@angular/animations';
import { Router } from '@angular/router';
import { SettingsService } from '../../core/http/settings.service';
import { BillingService } from '../../core/http/billing.service';
import { AuthServiceService } from '../../core/http/auth-service.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import * as _moment from 'moment';
const moment = _moment;

@Component({
  selector: 'app-cashier',
  templateUrl: './cashier.component.html',
  styleUrls: ['./cashier.component.scss'],
  animations: [
    trigger('slideInOut', [
      transition(':enter', [
        style({ transform: 'translateY(-100%)' }),
        animate('200ms ease-in', style({ transform: 'translateY(0%)' })),
      ]),
      transition(':leave', [
        animate('200ms ease-in', style({ transform: 'translateY(-100%)' })),
      ]),
    ]),
  ],
})
export class CashierComponent implements OnInit {
  isVisible = false;
  visible = false;
  items;
  filteredItems;
  isLoading = true;
  Errors = null;
  data = [];
  price = [];
  opdPrice: any = [];
  total = 0.0;
  net = 0.0;
  discount = 2;
  total_discount: any = 0;
  discount_amout = 0.0;
  amount_owing: number = 0.0;
  amountRemaining: number = 0;
  amount_paid: number = 0.0;
  total_Paid: number = 0.0;
  private _searchText: string;
  encounters: any = [];
  name;
  id;
  refDr;
  payType;
  success;
  buildLoad: boolean = false;
  startdate = '';
  enddate = '';
  dept_code = 0;
  sub_dept_code = 0;
  investigation = '';
  patientNmae = '';
  gender = '';
  phone = '';
  depts: any = [];
  subDepts: any = [];
  investigatonList: any = [];
  is_verified;
  acountStat: any = [];
  billbutton = false;

  stateForm = new FormGroup({
    receipt_id: new FormControl(''),
    receipt_no: new FormControl(''),
    bill_id: new FormControl(''),
    bill_no: new FormControl(''),
    registration_no: new FormControl('', Validators.required),
    patient_first_name: new FormControl('', Validators.required),
    patient_last_name: new FormControl(''),
    receipt_date: new FormControl(''),
    bill_amount: new FormControl('', Validators.required),
    amount_paid: new FormControl(''),
    author_id: new FormControl(''),
    author_name: new FormControl(''),
    payment_ref: new FormControl(''),
    payment_type: new FormControl('', Validators.required),
  });

  get formControls(): any {
    return this.stateForm['controls'];
  }

  constructor(
    public router: Router,
    private modal: ModalService,
    private _snackBar: MatSnackBar,
    public setting: SettingsService,
    public auth: AuthServiceService,
    public bill: BillingService
  ) {}

  ngOnInit(): void {
    let date = new Date();
    let currentDate = moment(date).format('YYYY-MM-DD');
    this.getStat();

    this.bill
      .searchEncounters(
        currentDate,
        currentDate,
        this.dept_code,
        this.sub_dept_code,
        this.investigation,
        this.patientNmae,
        this.gender,
        this.phone,
        this.is_verified,
        -1,
        -1,
        -1,
        -1
      )
      .subscribe(
        (resSuccess) => {
          // this.encounters = resSuccess
          let encounters;
          encounters = resSuccess.data.map((item) => ({
            selected: false,
            Bill_ID: item.Bill_ID,
            Bill_No: item.Bill_No,
            Recd_Payment: item.Recd_Payment,
            amountOutstanding: item.amountOutstanding,
            amountPaid: item.amountPaid,
            billDate: item.billDate,
            branchCode: item.branchCode,
            concession_code: item.concession_code,
            discount: item.discount,
            id: item.id,
            narration: item.narration,
            netAmount: item.netAmount,
            patientName: item.patientName,
            patient_type: item.patient_type,
            ref_hosp_code: item.ref_hosp_code,
            referred_doctor: item.referred_doctor,
            registration_no: item.registration_no,
            totalAmount: item.totalAmount,
          }));
          this.encounters = encounters;
          console.log(this.encounters);
          this.isLoading = false;
        },
        (resErr) => {
          this.isLoading = false;
          this.Errors = resErr;
        }
      );

    this.bill.getPatTypes().subscribe(
      (resSuccess) => {
        this.payType = resSuccess;
        this.isLoading = false;
      },
      (resErr) => {
        this.isLoading = false;
        this.Errors = resErr;
      }
    );
  }

  formatData() {
    this.discount_amout = this.total - this.total_Paid;
  }
  getStat() {
    this.bill.getAcountStat().subscribe(
      (resSuccess) => {
        this.acountStat = resSuccess;
      },
      (resErr) => {
        this.Errors = resErr;
      }
    );
  }

  onChangeTotla() {
    this.formatData();
    this.amount_owing = this.net - this.total_Paid;
    if (this.total_Paid > this.net) {
      this._snackBar.open('Please Check Amount Entered', '', {
        duration: 2000,
        verticalPosition: 'top',
      });
      this.amount_owing = 0;
      this.total_Paid = 0;
    } else {
    }
  }

  setItem(item) {
    let i;
    for (i = 0; i < this.encounters.length; i++) {
      this.encounters[i].selected = false;
    }
    this.total_Paid = item.amountPaid;
    this.total = item.totalAmount;
    this.net = item.netAmount;
    this.amount_owing = item.amountOutstanding;
    this.amountRemaining = item.amountOutstanding;
    this.name = item.patientName;
    this.refDr = item.referred_doctor;
    this.id = item.id;
    this.discount_amout = item.discount;

    let index = this.encounters.indexOf(item);
    if (item.selected == false) {
      item.selected = true;
      this.encounters[index] = item;
    } else {
      item.selected = false;
      this.encounters[index] = item;
    }

    this.stateForm.patchValue({
      receipt_id: item.receipt_id,
      receipt_no: item.receipt_no,
      bill_id: item.Bill_ID,
      bill_no: item.Bill_No,
      registration_no: item.registration_no,
      patient_first_name: item.patientName,
      patient_last_name: item.patient_last_name,
      receipt_date: item.receipt_date,
      bill_amount: item.totalAmount,
      amount_paid: item.amount_paid,
      payment_ref: item.payment_ref,
    });
  }
  updateForm() {
    this.stateForm.patchValue({
      amount_paid: this.total_Paid,
    });
  }

  searchEcounters() {
    this.isLoading = true;
    this.bill
      .searchEncounters(
        this.startdate,
        this.enddate,
        this.dept_code,
        this.sub_dept_code,
        this.investigation,
        this.patientNmae,
        this.gender,
        this.phone,
        this.is_verified,
        -1,
        -1,
        -1,
        -1
      )
      .subscribe(
        (resSuccess) => {
          this.visible = !this.visible;
          let encounters;
          encounters = resSuccess.data.map((item) => ({
            selected: false,
            Bill_ID: item.Bill_ID,
            Bill_No: item.Bill_No,
            Recd_Payment: item.Recd_Payment,
            amountOutstanding: item.amountOutstanding,
            amountPaid: item.amountPaid,
            billDate: item.billDate,
            branchCode: item.branchCode,
            concession_code: item.concession_code,
            discount: item.discount,
            id: item.id,
            narration: item.narration,
            netAmount: item.netAmount,
            patientName: item.patientName,
            patient_type: item.patient_type,
            ref_hosp_code: item.ref_hosp_code,
            referred_doctor: item.referred_doctor,
            registration_no: item.registration_no,
            totalAmount: item.totalAmount,
            refundAmount: item.refundAmount,
          }));
          this.encounters = encounters;
          this.isLoading = false;
          console.log(resSuccess);
        },
        (resErr) => {
          this.isLoading = false;
          this.Errors = resErr;
        }
      );
  }

  makeVisible() {
    this.visible = !this.visible;
  }
  startDateChange(event: any) {
    this.startdate = moment(event.target.value).format('YYYY-MM-DD');
    console.log(this.startdate, this.dept_code);
  }
  endDateChange(event: any) {
    this.enddate = moment(event.target.value).format('YYYY-MM-DD');
    console.log(this.enddate);
  }

  onSubmit(e) {
    this.buildLoad = true;
    e.preventDefault();
    this.updateForm();
    this.Errors = null;
    console.log(this.stateForm.value);
    const {
      receipt_id,
      receipt_no,
      bill_id,
      bill_no,
      registration_no,
      patient_first_name,
      patient_last_name,
      receipt_date,
      bill_amount,
      amount_paid,
      author_id,
      author_name,
      payment_ref,
      payment_type,
    } = this.stateForm.value;
    console.log(this.stateForm.value);
    this.bill
      .postPayment(
        receipt_id,
        receipt_no,
        bill_id,
        bill_no,
        registration_no,
        patient_first_name,
        patient_last_name,
        receipt_date,
        bill_amount,
        amount_paid,
        author_id,
        author_name,
        payment_ref,
        payment_type
      )
      .subscribe(
        (resSuccess) => {
          this.buildLoad = false;
          this.success = resSuccess;
          this.isLoading = false;
          console.log(resSuccess);

          if (this.success.success) {
            // this.closeModal()
            this._snackBar.open('Saved Successfully', '', {
              duration: 2000,
              verticalPosition: 'top',
            });
            this.router.navigateByUrl('/ledger');
            this.getStat();
          } else {
            this.Errors = 'Not successful, please try again';
            this._snackBar.open('Not successful, please try again', '', {
              duration: 4000,
              verticalPosition: 'top',
            });
            console.log(resSuccess);
          }
        },
        (resErr) => {
          this.buildLoad = false;
          this.Errors = resErr;
          console.log(resErr);
        }
      );
  }
}
